module.exports = __webpack_public_path__ + "static/media/financial.8c8f121e.svg";